var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status.error)?_c('div',{staticClass:"text-center mt-2 mb-2"},[_c('b-alert',{attrs:{"variant":_vm.status.color,"show":""}},[_c('div',{staticClass:"alert-body"},[_c('span',[_vm._v(_vm._s(_vm.status.message))])])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }